import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, ArrowRight } from "lucide-react";
import { Api } from "../lib/api";
import useStripePolling from "./booking-success/useStripePolling";
import QrTicket from "./booking-success/QrTicket";
import ShareCard from "./booking-success/ShareCard";

function pickTitle({ swish, paid }) {
  if (swish) return "Swish confirmation";
  if (paid) return "Booking confirmed!";
  return "Booking submitted";
}

function pickSubtitle({ swish, paid, status, total, phone }) {
  if (swish) {
    return `Send ${total || ""} SEK via Swish to ${
      phone || "the number provided"
    }. We'll confirm your seats by email within 24 hours.`;
  }
  if (paid) {
    return "A confirmation email is on its way. Show the QR code below at the pier.";
  }
  return `Status: ${status}. We're finalising your booking…`;
}

function StatusHero(props) {
  return (
    <div className="text-center">
      <div className="w-20 h-20 mx-auto rounded-full bg-coral/10 text-coral flex items-center justify-center mb-6">
        <CheckCircle2 size={36} />
      </div>
      <h1 className="heading-xl">{pickTitle(props)}</h1>
      <p className="body-lead mt-3">{pickSubtitle(props)}</p>
    </div>
  );
}

export default function BookingSuccessPage() {
  const [sp] = useSearchParams();
  const sid = sp.get("sid");
  const swish = sp.get("swish");
  const bookingId = sp.get("booking");
  const total = sp.get("total");
  const phone = sp.get("phone");
  const shareFromQs = sp.get("share");

  const [booking, setBooking] = useState(null);
  useEffect(() => {
    if (!bookingId) return;
    Api.getBooking(bookingId).then(setBooking).catch(() => {});
  }, [bookingId]);

  const status = useStripePolling(sid);
  const paid = status === "paid";
  const showQr = bookingId && (paid || swish || status === "confirmed");
  const shareCode = booking?.share_code || shareFromQs;

  return (
    <div
      className="container-x py-16 md:py-24 max-w-2xl mx-auto"
      data-testid="booking-success-page"
    >
      <StatusHero
        swish={swish}
        paid={paid}
        status={status}
        total={total}
        phone={phone}
      />

      {showQr && <QrTicket bookingId={bookingId} />}

      {shareCode && <ShareCard shareCode={shareCode} />}

      <div className="mt-8 text-center">
        <Link to="/" className="btn-primary" data-testid="back-home-btn">
          Back home <ArrowRight size={16} />
        </Link>
      </div>
    </div>
  );
}
